import { render, staticRenderFns } from "./IncomeTransactions.vue?vue&type=template&id=dd30d8e4&scoped=true"
import script from "./IncomeTransactions.vue?vue&type=script&lang=js"
export * from "./IncomeTransactions.vue?vue&type=script&lang=js"
import style0 from "./IncomeTransactions.vue?vue&type=style&index=0&id=dd30d8e4&prod&lang=scss"
import style1 from "./IncomeTransactions.vue?vue&type=style&index=1&id=dd30d8e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd30d8e4",
  null
  
)

export default component.exports